module.exports = __webpack_public_path__ + "static/media/dest-blue.526f56df.svg";